<template>
    <div class="container admin-table-page">
        <!-- Fila del título y flecha hacia atrás -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="d-flex align-items-center">
                    <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" class="back-icon" />
                    </b-button>
                    <h2 class="param-title">{{ labels.title }}</h2>
                </div>
            </div>
        </div>
        <!-- Fila de filtros debajo del título a la izquierda -->
        <div class="param-title-wrap niif-header">
            <div class="d-flex align-items-center w-100">
                <div class="filters-container d-flex align-items-center">
                    <label>{{ labels.fechaIni }}</label>
                    <b-form-input
                        v-model="fechaIni"
                        type="date"
                        class="reset-input mt-2 mx-2"
                    ></b-form-input>
                    <label>{{ labels.fechaFin }}</label>
                    <b-form-input
                        v-model="fechaFin"
                        type="date"
                        class="reset-input mt-2 mx-2"
                    ></b-form-input>
                    <b-button
                        class="consult-btn ml-2"
                        @click="consultaReporte()"
                        :disabled="!fechaIni || !fechaFin"
                    >
                        <font-awesome-icon :icon="['fas', 'search']" class="mr-1" />
                        {{ labels.consultar }}
                    </b-button>
                </div>
            </div>
        </div>
        <div class="admin-table-block mt-4">
            <div v-if="!isLoading">
                <CorporateDataTable
                    :items="lstContratos"
                    :fields="allFields"
                    :labels="tableLabels"
                    :default-per-page="10"
                    :page-options="[10, 20, 50, 100]"
                    :narrow="false"
                    :table-min-height="500"
                    :table-max-height="500"
                    :show-search="showSearchTable"
                    :allow-column-toggle="true"
                    :enable-sorting="true"
                    :filter-defs="tableFilterDefs"
                    :toolbar-disabled="!showToolbarExtras"
                >
                    <template #toolbar-actions>
                        <div class="niif-toolbar-right">
                            <b-button
                                size="sm"
                                class="table-toolbar-excel-btn"
                                @click="generaReporte()"
                                :disabled="!showToolbarExtras || lstContratos.length === 0"
                            >
                                <font-awesome-icon :icon="['fas', 'file-excel']" class="mr-1" />
                            </b-button>
                        </div>
                    </template>
                    <template #cell(valor_contrato)="data">
                        <div class="text-right">{{ formatNumber(data.item?.valor_contrato) }}</div> 
                    </template>
                    <template #cell(estado)="data">
                        <div class="text-left">{{ data.item?.estado == 'Inicial' ? 'Vigente' : data.item?.estado }}</div> 
                    </template>
                </CorporateDataTable>
            </div>

            <!-- Spinner de carga -->
            <div v-if="isLoading" class="text-center py-5">
                <b-spinner></b-spinner>
                <p class="mt-2">{{ labels.loading }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato'; 
import Authentication from "../../services/Authentication"; 
import * as XLSX from "exceljs";
import CorporateDataTable from '../utils/CorporateDataTable.vue'

export default {
    name : 'InformacionContratos',
    components : {CorporateDataTable},
    data : () => ({
        btnGenExcel : false,
        lstContratos : [],
        fechaIni : '',
        fechaFin : '',
        nameCompania : '',
        isLoading : false,
        showToolbarExtras: false
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") { 
                return {
                    title: "Información contratos",
                    fechaIni: 'Desde',
                    fechaFin: 'Hasta',
                    consultar: 'Consultar',
                    contrato : 'Contrato',
                    arrendador : 'Arrendador',
                    tipoContrato : 'Tipo contrato',
                    valContrato : 'Valor contrato',
                    fechActivacion : 'Fecha activación',
                    fechInicial : 'Fecha inicial',
                    fechFin : 'Fecha final',
                    state : 'Estado',
                    loading: 'Cargando...',
                    noData: 'No hay datos disponibles',
                    noMatches: 'No se encontraron resultados',
                    searchPlaceholder: 'Buscar en la tabla...',
                    rowsPerPage: 'Filas por página:',
                    noSort: 'Sin orden',
                    sortAsc: 'A-Z / Menor a mayor',
                    sortDesc: 'Z-A / Mayor a menor',
                    columns: 'Columnas',
                    showAllColumns: 'Mostrar todas',
                    filters: 'Filtros',
                    clearFilters: 'Limpiar filtros',
                    filterContrato : 'Filtrar contrato...',
                    filterArrendador : 'Filtrar arrendador...',
                    filterTipoContra : 'Filtrar tipo contrato...',
                    filterValorContra : 'Filtrar valor contrato...',
                    filterFechaAct : 'Filtrar fecha activación...',
                    filterFechaIni : 'Filtrar fecha inicial...',
                    filterFechaFin : 'Filtrar fecha final...',
                    filterEstado : 'Filtrar estado...'
                }
            }else{
                return {
                    title: "Contract information",
                    fechaIni: 'From',
                    fechaFin: 'Until',
                    consultar: 'Consult',
                    contrato : 'Contract',
                    arrendador : 'Lessor',
                    tipoContrato : 'Contract type',
                    valContrato : 'Contract value',
                    fechActivacion : 'Activation date',
                    fechInicial : 'Starting date',
                    fechFin : 'End date',
                    state : 'State',
                    loading: 'Loading...', 
                    noData: 'No data available',
                    noMatches: 'No results found',
                    searchPlaceholder: 'Search in table...',
                    rowsPerPage: 'Rows per page:',
                    noSort: 'No sorting',
                    sortAsc: 'A-Z / Low to high',
                    sortDesc: 'Z-A / High to low',
                    columns: 'Columns',
                    showAllColumns: 'Show all',
                    filters: 'Filters',
                    clearFilters: 'Clear filters',
                    filterContrato : 'Filter contract...',
                    filterArrendador : 'Filter landlord...',
                    filterTipoContra : 'Filter by contract type...',
                    filterValorContra : 'Filter by contract value...',
                    filterFechaAct : 'Filter by activation date...',
                    filterFechaIni : 'Filter by start date...',
                    filterFechaFin : 'Filter by end date...',
                    filterEstado : 'Filter by status...'
                }
            }
        },
        allFields() {
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center', tdClass: 'text-center align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'arrendador', label: this.labels.arrendador, sortable: true, thClass: 'text-left', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '350px' } } ,
                { key: 'tipo_contrato', label: this.labels.tipoContrato, sortable: true, thClass: 'text-left', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '100px' } },
                { key: 'valor_contrato', label: this.labels.valContrato, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'fecha_activacion', label: this.labels.fechActivacion, sortable: true, thClass: 'text-left', tdClass: 'text-end align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'fecha_inicial', label: this.labels.fechInicial, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'fecha_final', label: this.labels.fechFin, thClass: 'text-center', tdClass: 'text-end align-middle', sortable: false, thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } },
                { key: 'estado', label: this.labels.state, sortable: true, thClass: 'text-center', tdClass: 'text-start align-middle', thStyle: { whiteSpace: 'nowrap', minWidth: '150px' } }
            ]
        },
        tableFilterDefs() {
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'arrendador', type: 'text', placeholder: this.labels.filterArrendador },
                { key: 'tipo_contrato', type: 'text', placeholder: this.labels.filterTipoContra },
                { key: 'valor_contrato', type: 'text', placeholder: this.labels.filterValorContra },
                { key: 'fecha_activacion', type: 'text', placeholder: this.labels.filterFechaAct },
                { key: 'fecha_inicial', type: 'text', placeholder: this.labels.filterFechaIni },
                { key: 'fecha_final', type: 'text', placeholder: this.labels.filterFechaFin },
                { key: 'estado', type: 'text', placeholder: this.labels.filterEstado }
            ]
        },
        tableLabels() {
            return {
                noRow: this.labels.noData,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        },
        showSearchTable() {
            return true
        }
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 })?.format(value); 
        },
        async consultaReporte(){

            if (!this.fechaIni || !this.fechaFin){
                return this.$toast.error('Diligenciar la fecha.');
            }
            
            this.isLoading = true;

            try {

                const res = await Contrato.getContratosByFechaInicio_FechaFin(this.fechaIni,this.fechaFin)
                this.lstContratos = res.data.qryContratos || [];
                this.showToolbarExtras = this.lstContratos.length > 0;

                if (!this.lstContratos.length) {
                    this.$toast.error("No hay datos para las fechas seleccionadas.");
                }

                
            } catch (error) {
                console.error('Error en consultarReporte:', error);
                this.lstContratos = [];
                this.showToolbarExtras = false;
            
            } finally {
                this.isLoading = false;
            }
        },
        async generaReporte(){

            const {Workbook} = XLSX
            const workbook = new Workbook()
            const worksheet = workbook.addWorksheet("Lista de contratos") 

            const titulo = ['Lista de contratos']
            worksheet.addRow(titulo) 
            worksheet.mergeCells('A1:H1') 
            worksheet.getCell('A1').font = { name: 'Arial', bold : true, size : 12}; 
            worksheet.getCell('A1').alignment = { horizontal : 'center'}; 

            // =======================
            // FILA 2 - INFO GENERAL (richText)
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A2:H2'); 

            const cell2 = worksheet.getCell('A2'); 

            cell2.value = { 
                richText: [
                    { text: 'Desde: ', font: { bold: true } },
                    { text: `${this.fechaIni} | ` }, 

                    { text: 'Hasta: ', font: { bold: true } },
                    { text: `${this.fechaFin}` } 
                ]
            };

            cell2.font = { name: 'Arial', size: 12 }; 
            cell2.alignment = { horizontal: 'center', vertical: 'middle' }; 

            // =======================
            // FILA 3 - INFO GENERACION (richText)
            // =======================
            worksheet.addRow(['']); 
            worksheet.mergeCells('A3:H3'); 

            const cell3 = worksheet.getCell('A3'); 

            cell3.value = { 
                richText: [

                    { text: 'Generado por: ', font: { bold: true } },
                    { text: `${this.$store.state.userName} | ` }, 

                    { text: 'Fecha generación: ', font: { bold: true } },
                    { text: `${this.fechaActual()} | ` }, 

                    { text: 'Compañía: ', font: { bold: true } },
                    { text: `${this.nameCompania}` } 
                ]
            };

            cell3.font = { name: 'Arial', size: 12 }; 
            cell3.alignment = { horizontal: 'center', vertical: 'middle' }; 

            worksheet.addRow(['']); 
            worksheet.mergeCells('A4:H4') 

            const headerRow = worksheet.addRow([ 
                'Contrato',
                'Arrendador',
                'Tipo contrato',
                'Valor contrato',
                'Fecha activación',
                'Fecha inicial',
                'Fecha fin',
                'Estado'
            ])

            // Estilo de títulos
            headerRow.eachCell(cell => { 
                cell.font = { name: 'Arial', size: 12, bold: true } 
                cell.alignment = { horizontal: 'center' } 
            })

            this.lstContratos.map((e) => { 
                worksheet.addRow([ 
                    e.nro_contrato, 
                    e.arrendador, 
                    e.tipo_contrato, 
                    Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(e.valor_contrato), 
                    e.fecha_activacion, 
                    e.fecha_inicial, 
                    e.fecha_final, 
                    e.estado == 'Inicial' ? 'Vigente' : e.estado 
                ])
            })

            //Poner borde
            const border = {
                top : {style : 'thin'},
                left : {style : 'thin'},
                bottom : {style : 'thin'},
                right : {style : 'thin'},
            }

            for( let row = 1; row <= worksheet.rowCount; row++){ 

                if ([1, 2, 3, 4].includes(row)) continue; // 👈 omitir filas 
                for( let col = 1; col <= worksheet.columnCount; col++){ 
                    worksheet.getCell(row, col).border = border; 
                }
            }
            //------

            const file = await workbook.xlsx.writeBuffer() 
            const downloadLink = document.createElement("a") 
            downloadLink.download = "Lista de contratos.xlsx" 
            downloadLink.href = window.URL.createObjectURL( 
                new Blob([file], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 
                })
            )

            downloadLink.style.display = "none"; 

            document.body.appendChild(downloadLink); 
            downloadLink.click(); 

            downloadLink.remove(); 
        },
        fechaActual(){
            const fecha = new Date()

            const año = fecha.getFullYear() 
            const mes = String(fecha.getMonth() + 1).padStart(2, '0') // getMonth() va de 0 a 11 
            const dia = String(fecha.getDate()).padStart(2, '0') 

            return `${año}-${mes}-${dia}`
        },
    },
    mounted(){
        Authentication.leaParametros() 
        .then ((result) => { 
            this.nameCompania = result.data.parametros.compania 
        })
        .catch((err) => console.log(err)) 
    },
    watch:{
        fechaIni(val){
            if(val == ""){
                this.lstContratos = [] 
                this.showToolbarExtras = false;
            }
        },
        fechaFin(val){
            if(val == ""){
                this.lstContratos = [] 
                this.showToolbarExtras = false;
            }
        }
    }
}
</script>

<style src="../main.css"> 
</style>
<style scoped>
/* Estilos para el contenedor de filtros - ahora a la izquierda */
.niif-header .filters-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    margin-left: 0 !important;
}

.niif-header .filter-select {
    min-width: 200px;
    max-width: 280px;
    width: auto;
    height: 38px;
    font-size: 14px;
    border-radius: 7px;
}

/* Para que el texto de las opciones se vea completo */
.niif-header .filter-select option {
    white-space: normal;
    word-break: break-word;
    padding: 4px 8px;
}

.niif-header .consult-btn {
    height: 38px;
    min-height: 38px;
    padding: 0 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    border-radius: 7px;
    font-size: 14px;
    background-color: #6c757d !important;
    color: white !important;
    border: 1px solid #6c757d !important;
    cursor: pointer;
    flex-shrink: 0;
}

.niif-header .consult-btn:hover,
.niif-header .consult-btn:focus,
.niif-header .consult-btn:active,
.niif-header .consult-btn:not(:disabled):hover,
.niif-header .consult-btn:not(:disabled):focus,
.niif-header .consult-btn:not(:disabled):active {
  background-color: #6c757d !important;
  color: white !important;
  border-color: #6c757d !important;
  box-shadow: none !important;
}

.niif-header .consult-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background-color: #6c757d !important;
  color: white !important;
  border-color: #6c757d !important;
}

/* Estilos para la flecha y título */
.page-back-btn {
  padding: 0;
  font-size: 1.5rem;
  line-height: 1;
}

.back-icon {
  font-size: 1.75rem !important;
  width: 1.75rem !important;
  height: 1.75rem !important;
}

.param-title {
  font-size: 2rem !important;
  font-weight: 500;
}

.niif-toolbar-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex: 0 0 auto;
}

.table-toolbar-excel-btn {
  height: 31px;
  min-height: 31px;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 7px;
  font-size: 13px;
  background-color: #016690;
  color: white;
  border: 1px solid #085170;
}

.table-toolbar-excel-btn:hover:not(:disabled) {
  background-color: #085170;
  border-color: #0e3a4d;
}

.table-toolbar-excel-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
}

/* Ajustes responsivos */
@media (max-width: 1200px) {
  .niif-header .filter-select {
    min-width: 160px;
    max-width: 220px;
    height: 36px;
    font-size: 13px;
  }
  
  .niif-header .consult-btn {
    height: 36px;
    min-height: 36px;
    font-size: 13px;
    padding: 0 16px;
  }
}

@media (max-width: 992px) {
  .niif-header .filters-container {
    flex-wrap: wrap;
    width: 100%;
    margin-top: 8px;
    margin-left: 0 !important;
    justify-content: flex-start;
    gap: 6px;
  }
  
  .niif-header .filter-select {
    min-width: 150px;
    max-width: 200px;
    height: 36px;
    font-size: 13px;
    flex: 1 1 auto;
  }
  
  .niif-header .consult-btn {
    height: 36px;
    min-height: 36px;
    font-size: 13px;
    padding: 0 16px;
  }
}

@media (max-width: 576px) {
  .param-title {
    font-size: 1.5rem !important;
  }
  
  .niif-header .filter-select {
    min-width: 100%;
    max-width: 100%;
    height: 36px;
    font-size: 13px;
    flex: 0 0 100%;
  }
  
  .niif-header .filters-container {
    gap: 4px;
  }
  
  .niif-header .consult-btn {
    width: 100%;
    flex: 0 0 100%;
    height: 36px;
    margin-left: 0 !important;
    margin-top: 4px;
  }
}
</style>